import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, qs } from "@/lib/api";
import { Card, SectionTitle } from "@/components/Kpi";
import { ComparisonChart } from "@/components/Charts";

function GraficoCollegato({ grafico, commerciale }) {
  const [dati, setDati] = useState(null);
  useEffect(() => {
    api.get(`/grafici/${grafico.id}/dati?${qs({ anno: 2026, commerciale })}`)
      .then((r) => setDati(r.data)).catch(() => setDati(null));
  }, [grafico.id, commerciale]);
  return (
    <Card className="p-4" data-testid={`pagina-grafico-${grafico.id}`}>
      <ComparisonChart testId={`chart-${grafico.id}`} height={320} type={grafico.tipo}
        title={grafico.nome} data={dati?.righe || []} keys={dati?.keys || []}
        labelFormat={grafico.formato === "num" ? "int" : "compact"}
        emptyNote="nessun dato per questo grafico" />
    </Card>
  );
}

/** Pagina creata dall'utente dalla struttura del menu (Impostazioni → Configurazioni). */
export default function PaginaCustom() {
  const { slug, comm } = useParams();
  const [d, setD] = useState(null);
  const [errore, setErrore] = useState(false);

  useEffect(() => {
    setD(null);
    setErrore(false);
    api.get(`/menu-struttura/pagina/${slug}`).then((r) => setD(r.data)).catch(() => setErrore(true));
  }, [slug]);

  if (errore) {
    return <div className="text-sm text-slate-500" data-testid="pagina-custom-errore">
      Pagina non trovata o eliminata.
    </div>;
  }
  if (!d) return <div className="text-sm text-slate-500" data-testid="pagina-custom-loading">Caricamento…</div>;

  return (
    <div data-testid={`pagina-custom-${slug}`}>
      <SectionTitle sub={d.grafici.length
        ? `${d.grafici.length} grafici collegati${comm ? ` · filtrati su ${comm.replace(/-/g, " ")}` : ""}`
        : `Pagina vuota · collega i grafici salvati da Impostazioni → Configurazioni${
            comm ? ` · filtrata su ${comm.replace(/-/g, " ")}` : ""}`}>
        {d.pagina.nome}
      </SectionTitle>
      {d.grafici.length ? (
        <div className="space-y-6">
          {d.grafici.map((g) => <GraficoCollegato key={g.id} grafico={g} commerciale={comm} />)}
        </div>
      ) : (
        <Card className="p-10 text-center text-slate-500" data-testid="pagina-custom-vuota">
          Questa pagina è in preparazione: collega qui i grafici salvati oppure dimmi cosa inserire.
        </Card>
      )}
    </div>
  );
}
